import { alpha, darken, DialogActions, DialogContent } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { parseErrorMessage } from '../../../../../core/api/api.context';
import { Modal } from '../../../../../ui/components/pure/modal/modal.component';
import { Snackbar } from '../../../../../ui/components/pure/snackbar/snackbar.component';
import { TextButton } from '../../../../../ui/components/pure/text-button/text-button.component';
import { Colors } from '../../../../../ui/theme/colors';
import { UnreserveContainerActionProps, useUnreserveContainerAction } from './unreserve-container-action.hook';

export function UnreserveContainerActionModal(props: UnreserveContainerActionProps) {
  const { container, reservedForRecipients, error, submitting, handlers } = useUnreserveContainerAction(props);

  if (container.error) {
    return (
      <Snackbar severity="error" onClose={() => props.onAbort()}>
        Sorry, there was an error getting the delivery container details. Please try again.
      </Snackbar>
    );
  }

  return (
    <Modal
      title="Unreserve delivery container"
      open={true}
      loading={container.isLoading || submitting}
      maxWidth="xs"
      onClose={handlers.onCancelIntent}
    >
      <DialogContent style={{ padding: '16px 24px', fontSize: '14px' }}>
        {error ? (
          <Alert variant="outlined" severity="error" style={{ marginBottom: '12px' }}>
            <AlertTitle>Something went wrong</AlertTitle>
            {parseErrorMessage(error.message)}
          </Alert>
        ) : null}
        <p>This delivery container is currently reserved for:</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', margin: '12px 0' }}>
          {reservedForRecipients.map((party) => (
            <Alert
              key={party.id}
              severity="success"
              icon={false}
              style={{
                backgroundColor: alpha(Colors.collectedGreen, 0.12),
                border: `1px solid ${darken(Colors.collectedGreen, 0.2)}`,
                color: darken(Colors.collectedGreen, 0.45)
              }}
            >
              <AlertTitle style={{ fontWeight: 600, marginBottom: party.unit ? '4px' : 0 }}>{party.name}</AlertTitle>
              {party.unit || null}
            </Alert>
          ))}
        </div>
        <p>Are you sure you want to remove this reservation?</p>
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
        <TextButton color="secondary" variant="outlined" onClick={handlers.onCancelIntent}>
          Cancel
        </TextButton>
        <TextButton
          color="danger"
          variant="outlined"
          disabled={reservedForRecipients.length === 0}
          onClick={handlers.onConfirm}
        >
          Unreserve
        </TextButton>
      </DialogActions>
    </Modal>
  );
}
